import React from "react";
import { useSelector } from "react-redux";

import { IgCheckbox, IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { RenderCustomEventIcon } from "@src/features/customEvents/utils";
import {
  getCustomMetrics,
  getKeyMetricsRich,
} from "@src/store/slices/experienceMetrics/experienceMetrics";

interface ArchivedEventListProps {
  keyMetricRender?: boolean;
}

export const ArchivedEventList = ({
  keyMetricRender,
}: ArchivedEventListProps) => {
  const theme = useTheme();
  const experienceKeyMetrics = useSelector(getKeyMetricsRich);
  const experienceCustomMetrics = useSelector(getCustomMetrics);

  const events = keyMetricRender
    ? experienceKeyMetrics
        .filter(
          (metric) => metric.experienceCustomMetric?.customEvent.archivedAtTs
        )
        .map((metric) => metric.experienceCustomMetric?.customEvent)
    : experienceCustomMetrics
        .filter((customMetric) => customMetric.customEvent.archivedAtTs)
        .map((customMetric) => customMetric.customEvent);

  return (
    <>
      {events.map((event) => {
        return (
          <Grid
            container
            direction={"row"}
            justifyContent={"space-between"}
            key={event?.id}
            alignItems={"center"}
            wrap={"nowrap"}
            sx={{
              marginTop: "20px",
            }}
          >
            <IgTooltip
              title={
                "Unarchive this event to edit, or to remove it from this test."
              }
            >
              <IgCheckbox
                disabled={true}
                checked={true}
                sx={{ marginRight: "10px" }}
              />
            </IgTooltip>
            <Grid
              item
              container
              direction={"row"}
              alignItems={"center"}
              wrap={"nowrap"}
            >
              {<RenderCustomEventIcon eventType={event?.type || "pageView"} />}
              <Grid container direction={"column"} sx={{ marginLeft: "15px" }}>
                <Grid container>
                  <IgTypography sx={{ color: theme.palette.text.tonal.error }}>
                    {event?.name}
                  </IgTypography>
                </Grid>
                <Grid container>
                  <IgTypography sx={{ color: theme.palette.text.tonal.error }}>
                    {event?.description}
                  </IgTypography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item wrap={"nowrap"} xs={2}></Grid>
          </Grid>
        );
      })}
    </>
  );
};
